import { Auth } from 'aws-amplify';
import { Amplify } from 'aws-amplify';
export const awsConfig = {
    Auth: {
        region: import.meta.env.VITE_REGION || 'us-east-1',
        userPoolId: import.meta.env.VITE_ADMIN_COGNITO_USERPOOL_ID,
        userPoolWebClientId: import.meta.env.VITE_ADMIN_COGNITO_CLIENT_ID,
        identityPoolId: import.meta.env.VITE_ADMIN_COGNITO_IDENTITY_POOL_ID,
        authenticationFlowType: 'USER_PASSWORD_AUTH'
    },
    Storage: {
        AWSS3: {
            bucket: import.meta.env.VITE_BUCKET_NAME,
            region: import.meta.env.VITE_REGION || 'us-east-1',
        }
    }
};
async function authenticateUser(username,password) {
    Amplify.configure(awsConfig)
    try {         
    // Authenticate user using username/email and password
        const loginResponse = await Auth.signIn(username, password);
    } catch (error) {
        console.error('Authentication Error:', error);
    }
}

export default authenticateUser;


  